import { render } from "./VabeneFidelitePage.vue?vue&type=template&id=795bf7e6&scoped=true&ts=true"
import script from "./VabeneFidelitePage.vue?vue&type=script&lang=ts"
export * from "./VabeneFidelitePage.vue?vue&type=script&lang=ts"

import "./VabeneFidelitePage.vue?vue&type=style&index=0&id=795bf7e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795bf7e6"]])

export default __exports__